import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
const AssignRegionForm = (props) => {
  const frmRef = useRef({});
  const [regions, setRegions] = useState();
  const [employeeData, setEmployeeData] = useState();
  const [filteredEmployees, setFilteredEmployees] = useState("");
  const [resionData, setResionData] = useState("");
  const[areaData,setAreaData]=useState([]);
  const[areaId,setAreaId]=useState(0);

  const { sendRequest: getAreaData } = useHttp();
  
  const FillDetail = () => {
    getAreaData(
      {
        url: `/api/areaDetails/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setAreaData(res);
        
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getAreaData]);

  const { sendRequest: getAssignResion } = useHttp();

  useEffect(() => {
    getAssignResion(
      {
        url: `/api/assignRegion/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log(data);
        const sortedData = data.sort((a, b) => {
          return new Date(b.createdDate) - new Date(a.createdDate);
        });
        setResionData(sortedData);
      }
    );
  }, [getAssignResion]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        // url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
        url: `/api/employeeByUsecase/?useCase=Procurement&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
       
        var empdata = data.output.filter(
          (item) => item.useCase == "Procurement"
        );
        var i = 0;
        //console.log("empdata", empdata);
        var tempempdata = empdata;
        var newempList = [];

        do {
          newempList = newempList.concat({
            userId: tempempdata[i].userId,

            useCase: tempempdata[i].useCase,
            empId: tempempdata[i].empId,
            employeeName: tempempdata[i].employeeName,

            regionId: tempempdata[i].regionId,
          });
          i++;
        } while (tempempdata.length > i);

        //console.log("newempList", newempList);

        setEmployeeData(newempList);
      }
    );
  }, [getEmp]);

  const handleRegionChange = (event, i) => {
    // //console.log(i);
    const selectedRegionId = event.target.value;
    event.preventDefault(false);
    // const updatedEmployeeData = employeeData.map((employee,i) => {
    //   return {
    //     ...employee,
    //    regionId: selectedRegionId,
    //   };
    // });

    const updatedEmployeeData = [...employeeData];
    updatedEmployeeData[i] = {
      ...updatedEmployeeData[i],
      regionId: selectedRegionId,
    };

    setEmployeeData(updatedEmployeeData);

    //console.log(updatedEmployeeData);
  };

  const handleAreaChange = (event, i) => {
    // //console.log(i);
    const selectedAreaId = event.target.value;
    event.preventDefault(false);
  

    const updatedEmployeeData = [...employeeData];
    updatedEmployeeData[i] = {
      ...updatedEmployeeData[i],
      areaId: selectedAreaId,
    };

    setEmployeeData(updatedEmployeeData);

    console.log(updatedEmployeeData);
  };

  const { sendRequest: getRegion } = useHttp();

  useEffect(() => {
    getRegion(
      {
        url: `/api/region/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("region 1", data);

        var regionsempdata = data.filter(
          (item) => item.regionType === "Procurement"
        );
        //console.log("regionsempdata", regionsempdata);
        setRegions(regionsempdata);
      }
    );
  }, [getRegion]);

  const { sendRequest: PostAssignRegion } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault(false);

    const promises =
      employeeData &&
      employeeData.map((emp) => {
        const data = {
          discountApprovalDate: moment(
            new Date().toISOString().slice(0, 10)
          ).format("DD/MM/YYYY"),

          procurementOfficerId: emp.empId,
          assignRegionDate: moment(
            new Date().toISOString().slice(0, 10)
          ).format("DD/MM/YYYY"),
          regionId: emp.regionId,
          areaId: emp.areaId,
          createdDate: moment(new Date().toISOString().slice(0, 10)).format(
            "DD/MM/YYYY"
          ),
          status: 1,
          orgId: parseInt(localStorage.getItem("orgId")),
          createdBy: parseInt(localStorage.getItem("id")),
          warehouseId: parseInt(localStorage.getItem("warehouseId")),
        };

        if (props.update.procurmentTargetId) {
          data["assignRegionId"] = props.update.assignRegionId;
        }

       // console.log(data);

        const existingRecord =
          resionData &&
          resionData.find(
            (target) => target.procurementOfficerId === emp.empId
          );
        if (existingRecord) {
          console.log(existingRecord);
       
          const dropdown = document.getElementById("region-dropdown");
          const empId = existingRecord.empId;
          const newRegionId = data.regionId;
          const employee = employeeData.find((emp) => emp.empId === empId);
          if (employee) {
            employee.dropdown.value = newRegionId;
          }

          return Promise.all([
            PostAssignRegion({
              url: `/api/assignRegion/`,
              method: "PUT",
              body: { ...existingRecord, status: 0 ,areaId: emp.areaId},
            }),
            PostAssignRegion({
              url: "/api/assignRegion/",
              method: "POST",
              body: data,
            }),
          ]);
        } else {
          return PostAssignRegion({
            url: "/api/assignRegion/",
            method: props.update.discountApprovalId ? "PUT" : "POST",
            body: data,
          });
        }
      });

    Promise.all(promises)
      .then(() => {
        toast.success(`Region  ${props.update ? "Updated" : "Added"}`);
         props.addForm(false);
      })
      .catch((error) => {
        toast.error(`Error: ${error.message}`);
      });
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Region Allocation </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row text-center">
                    <table className="table table-bordered text-center w-75 ">
                      <thead>
                        <tr>
                          <th>Procurement Officer Name</th>
                          <th>Region </th>
                          <th>Area Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {employeeData &&
                          employeeData.map((employee, i) => (
                            <tr key={i} >
                              <td>{employee.employeeName}</td>
                              <td>
                                {" "}
                                <select
                                  required
                                  id="region-dropdown"
                                  className="form-control"
                                  ref={(el) =>
                                    (frmRef.current["set_region"] = el)
                                  }
                                  autoComplete="off"
                                  value={employee.regionId}
                                  onChange={(event) =>
                                    handleRegionChange(event, i)
                                  }
                                >
                                  <option value="">select</option>
                                  {regions &&
                                    regions.map((region) => (
                                      <option
                                        key={region}
                                        value={region.regionId}
                                      >
                                        {region.regionName}
                                      </option>
                                    ))}
                                </select>
                              </td>
                              <td>
                                {" "}
                                <select
                                  required
                                  id="region-dropdown"
                                  className="form-control"
                                  ref={(el) =>
                                    (frmRef.current["set_region"] = el)
                                  }
                                  autoComplete="off"
                                  value={employee.areaId}
                                  onChange={(event) =>
                                    handleAreaChange(event, i)
                                  }
                                >
                                  <option value="0">select</option>
                                  {areaData &&
                                    areaData.map((area,idx) => (
                                      <option
                                        key={idx}
                                        value={area.areaId}
                                      >
                                        {area.areaName}
                                      </option>
                                    ))}
                                </select>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button className="btn  btn-primary mx-2 my-2" type="submit">
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default AssignRegionForm;
